<template>

<div>
  <link rel="stylesheet" :href="getStyles()" />
  <link rel="stylesheet" :href="getStyles2()" />
   <!-- Page Wrapper -->
  <div id="wrapper">

    <!-- Sidebar -->
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

      <!-- Sidebar - Brand -->
      <a class="sidebar-brand d-flex align-items-center justify-content-center" href="/admin-panel/">

        <div class="sidebar-brand-text mx-3">Mobius Admin</div>
      </a>

      <!-- Divider -->
      <hr class="sidebar-divider my-0" v-if="userPermission !== 'ROLE_STUDENT'">


      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT'">
        <router-link :to="'/admin-panel/questions'" class="nav-link">
          <font-awesome-icon icon="question" />
          <span>Preguntas</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/cursos'" class="nav-link">
          <font-awesome-icon icon="archive"/>
          <span>Cursos</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/Practices'" class="nav-link">
          <font-awesome-icon icon="fa-pen-to-square" />
          <span>Prácticas</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/exams'" class="nav-link">
          <font-awesome-icon icon="fa-file-pen" />
          <span>Exámenes</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/Tags'" class="nav-link">
          <font-awesome-icon icon="fa-tag" />
          <span>Tags</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/olimpiadas'" class="nav-link" :aria-disabled="true">
          <font-awesome-icon icon="bookmark" />
          <span>Olimpiadas</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/categorias'" class="nav-link">
          <font-awesome-icon icon="fa-swatchbook" />
          <span>Categorías</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
        <router-link :to="'/admin-panel/Subcategories'" class="nav-link">
          <font-awesome-icon icon="rectangle-list" />
          <span>Subcategorías</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">

      <li class="nav-item"  v-if="userPermission !== 'ROLE_STUDENT'">
        <router-link :to="'/admin-panel/simulacrums'" class="nav-link">
          <font-awesome-icon icon="chart-simple" />
          <span>Simulacros</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission === 'ROLE_ADMIN'">

      <li class="nav-item"  v-if="userPermission !== 'ROLE_STUDENT'">
        <router-link :to="'/admin-panel/lecciones'" class="nav-link">
          <font-awesome-icon icon="book-open-reader" />
          <span>Lecciones</span>
        </router-link>
      </li>

      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission === 'ROLE_ADMIN'">

      <li class="nav-item" v-if="userPermission === 'ROLE_ADMIN'">
        <router-link :to="'/admin-panel/users'" class="nav-link">
          <font-awesome-icon icon="users" />
          <span>Usuarios</span>
        </router-link>
      </li>

      <!-- Divider -->
      <hr class="sidebar-divider d-none d-md-block" v-if="userPermission === 'ROLE_ADMIN'">

      <!-- Sidebar Toggler (Sidebar) -->

    </ul>
    <!-- End of Sidebar -->

    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">

      <!-- Main Content -->
      <div id="content">

        <!-- Topbar -->
        <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

          <!-- Sidebar Toggle (Topbar) -->
          <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
            <i class="fa fa-bars"></i>
          </button>

          <!-- Topbar Navbar -->
          <ul class="navbar-nav ml-auto">

            <!-- Nav Item - Search Dropdown (Visible Only XS) -->
            <li class="nav-item dropdown no-arrow d-sm-none">
              <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-search fa-fw"></i>
              </a>
              <!-- Dropdown - Messages -->
              <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                   aria-labelledby="searchDropdown">
                <form class="form-inline mr-auto w-100 navbar-search">
                  <div class="input-group">
                    <input type="text" class="form-control bg-light border-0 small"
                           placeholder="Search for..." aria-label="Search"
                           aria-describedby="basic-addon2">
                    <div class="input-group-append">
                      <button class="btn btn-primary" type="button">
                        <i class="fas fa-search fa-sm"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </li>


            <!-- Nav Item - Messages -->
            <li class="nav-item dropdown no-arrow">
            <router-link :to="'/dashboard'" class="nav-link">
              <font-awesome-icon icon="fa-arrow-right-from-bracket" />
              <span>Volver al dashboard</span>
            </router-link>
            </li>
            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">

              <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <font-awesome-icon icon="user" />
                <span class="mr-2 d-none d-lg-inline text-gray-600 small">{{userName}} ({{roleName}})</span>
              </a>
              <!-- Dropdown - User Information -->
              <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                   aria-labelledby="userDropdown">
                <a class="dropdown-item" href="#">
                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                  Profile
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                  Settings
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                  Activity Log
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" data-toggle="modal" data-target="#logoutModal">
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  Logout
                </a>
              </div>
            </li>

          </ul>

        </nav>
        <!-- End of Topbar -->


          <!-- Page Heading -->
          <router-view></router-view>


      </div>
      <!-- End of Main Content -->

      <!-- Footer -->
      <footer class="sticky-footer bg-white">
        <div class="container my-auto">
          <div class="copyright text-center my-auto">
            <span>Copyright &copy; Mobius 2024</span>
          </div>
        </div>
      </footer>
      <!-- End of Footer -->

    </div>
    <!-- End of Content Wrapper -->

  </div>
  <!-- End of Page Wrapper -->

  <!-- Scroll to Top Button-->
  <a class="scroll-to-top rounded" href="#page-top">
    <i class="fas fa-angle-up"></i>
  </a>

  <!-- Logout Modal-->
  <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
          <button class="close" type="button" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">Select "Logout" below if you are ready to end your current session.</div>
        <div class="modal-footer">
          <button class="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
          <a class="btn btn-primary" href="login.html">Logout</a>
        </div>
      </div>
    </div>
  </div>



</div>
</template>

<script>

import { AUTHORITIES } from "../../Utils/constants/global.constants";

export default {
  name: "Admin",
  data: () => {
    return {
    userPermission: '',
    userName: "",
    role: "",
    roleName: ""
  }},
  beforeMount(){
    let auth = JSON.parse(window.localStorage.getItem("auth"));
    if (!auth.isAuthenticated) {
      window.location.href = '/'
    }
    this.userName =  auth.data.name;
    this.role = window.localStorage.getItem("role");
    this.roleName = this.getRoleName(this.role);

    if (this.role === 'ROLE_STUDENT') {
      window.location.href = '/'
    }
  },
  mounted() {
    this.userPermission =  localStorage.getItem("role")
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  methods: {
    getRoleName(role){
      return AUTHORITIES[role];
    },
    getStyles() {
      return new URL("../../assets/css/sb-admin-2.css", import.meta.url).href;
    },
    getStyles2() {
      return new URL("../../assets/css/styles.css", import.meta.url).href;
    },
  }
};
</script>
